module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.0fcdf14.ttf";